import { render, staticRenderFns } from "./ParentAccount.vue?vue&type=template&id=577ab806&scoped=true"
import script from "./ParentAccount.vue?vue&type=script&lang=js"
export * from "./ParentAccount.vue?vue&type=script&lang=js"
import style0 from "./ParentAccount.vue?vue&type=style&index=0&id=577ab806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ab806",
  null
  
)

export default component.exports